import { ObjectTransformation } from '../../common/Controls/ObjectTransformation';
import { IGuid, IType } from './ITypes';

export enum IAccountType {
    Partner = 'partner',
    Customer = 'customer'
}

export interface IAccount {
    Id: IGuid;
    Name: string;
}

/*
export async function accountsToTypes(data: IAccount[]): Promise<IType[]> {
    let arr: IType[] = [];
    data.map((a) => arr.push({ label: a.Name, value: a.Id }));
    return arr;
}*/

export const accountTypeTransformation: ObjectTransformation<IAccount, IType> = {
    objectToValue: (a: IAccount | null): IType | null => a ? { label: a.Name, value: a.Id } : null,
    valueToObject: (t: IType|null ): IAccount | null => t ? { Name: t.label, Id: t.value.toString() } : null
}